module.exports = __webpack_public_path__ + "static/media/Frame 1261154682.81d648d7.svg";